import {Component, OnInit} from '@angular/core';
import {environment} from "../../../../../../environments/environment";

interface VideoModel {
  name: string;
  url: string;
  isLoaded: boolean;
  poster: string;
}

@Component({
  selector: 'app-sponsorship-for-customer-modal',
  templateUrl: './sponsorship-for-customer-modal.component.html',
  styleUrls: ['./sponsorship-for-customer-modal.component.scss'],
})
export class SponsorshipForCustomerModalComponent implements OnInit {
  url = environment.fydlApi.url;
  private videos: VideoModel [] = [
    {
      name: 'fydl-sponsorship-bonus-points',
      url: this.url + '/assets/videos/sponsorship/sponsor-bonus-points.mp4',
      poster: 'assets/options-how-it-work-illustration/sponsorships/posters/sponsor-bonus-points.webp',
      isLoaded: false
    },
  ]

  constructor() { }

  ngOnInit() {}

  onLoadeddata(videName: string) {
    const index = this.videos.findIndex(video => video.name === videName);
    if (index >= 0) {
      this.videos[index].isLoaded = true;
    }
  }

  getVideoByName(name: string): VideoModel {
    return this.videos.find(video => video.name === name);
  }

  isLoaded(videoName: string): boolean {
    return this.videos.find(video => video.name === videoName).isLoaded;
  }
}
